/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-no-comment-textnodes */
import React, { useState } from 'react'
import { Button } from 'rsuite'
import './CardTable.scss'
import ToggleButton from '../../atoms/toggleButton/ToggleButton'
import { CardActionCell } from '../table/cells'
import DefaultCropIcon from '../../../assets/images/default-crop.svg'

interface CropCardProps {
  imageUrl: string;
  name?: string;
  onAction?: (eventKey: string | undefined, rowData: any) => void;
  data?: any;
  actionOptions?: string[];
  handleSelection?: (rowData: any) => void;
  selected?: boolean;
  handleCardClick?: (rowData: any) => void;
}
const CropCard: React.FC<CropCardProps> = ({
  imageUrl,
  name,
  onAction,
  data,
  actionOptions,
  handleSelection,
  selected = false,
  handleCardClick
}) => {
  const onCardClick = () => {
    if (handleCardClick) {
      handleCardClick(data)
    }
  }
  const [imgSrc, setImgSrc] = useState(imageUrl)
  const handleImageError = () => {
    setImgSrc(DefaultCropIcon)
  }
  return (
    <div className={`card ${selected ? 'selected' : ''}`}>
      <div
        className="card-header"
        onClick={onCardClick}
        role="button"
        tabIndex={0}
        onKeyPress={(event) => {
          if (event.key === 'Enter') onCardClick()
        }}
      >
        <img src={imgSrc} alt={name} onError={handleImageError} />
        <div onClick={(event) => event.stopPropagation()}>
          <ToggleButton
            isActive={data?.active}
            onToggle={() => {
              const actionKey = data?.active ? '6' : '5'
              onAction && onAction(actionKey, data)
            }}
          />
        </div>
      </div>
      <div className="card-body">
        <h3>{name}</h3>
        {handleSelection && (
          <Button
            className="select-button"
            onClick={() => {
              handleSelection(data)
            }}
          >
            {selected ? 'Deselect' : 'Select'}
          </Button>
        )}
      </div>
      {actionOptions && (
        <div className="card-action">
          <CardActionCell
            rowData={data}
            dataKey="action"
            onAction={onAction}
            actionOptions={actionOptions}
          />
        </div>
      )}
    </div>
  )
}
export default CropCard
